import extendedFieldDataTransformers from "ExtendedFields/dataTransformers";

const { fieldTypes } = extendedFieldDataTransformers;

const commonProperties = {
  visibility: "custom", // anything but default will do here
  isCustomField: true,
  blockSharing: 0,
};

const customProfileFieldHeaders = {
  [fieldTypes.address]: "Address",
  [fieldTypes.date]: "Date",
  [fieldTypes.number]: "Number",
  [fieldTypes.text]: "Text Box",
  [fieldTypes.selectlist]: "Select List",
  [fieldTypes.fileUpload]: "File Upload",
};

const customProfileFieldIcons = {
  [fieldTypes.address]: "fa-map-marked fas",
  [fieldTypes.date]: "fa-calendar fas",
  [fieldTypes.number]: "fa-calculator fas",
  [fieldTypes.text]: "fa-keyboard fas",
  [fieldTypes.selectlist]: "fa-ballot-check fas",
  [fieldTypes.fileUpload]: "fa-upload fas",
};

const extendedFieldsCustomFieldData = [
  {
    label: "Text",
    icon: customProfileFieldIcons[fieldTypes.text],
    fieldTypeID: 1, // text
    title: customProfileFieldHeaders[fieldTypes.text],
    id: "text",
    periodicIIGOn: true,
    ...commonProperties,
  },
  {
    label: "Number",
    icon: customProfileFieldIcons[fieldTypes.number],
    fieldTypeID: 3, // number
    title: customProfileFieldHeaders[fieldTypes.number],
    id: "number",
    ...commonProperties,
  },
  {
    label: "Address",
    icon: customProfileFieldIcons[fieldTypes.address],
    fieldTypeID: 4, // address
    title: customProfileFieldHeaders[fieldTypes.address],
    id: "address",
    periodicIIGOn: true,
    ...commonProperties,
  },
  {
    label: "Date",
    icon: customProfileFieldIcons[fieldTypes.date],
    fieldTypeID: 2, // date
    title: customProfileFieldHeaders[fieldTypes.date],
    id: "date",
    ...commonProperties,
  },
  {
    label: "Select List",
    icon: customProfileFieldIcons[fieldTypes.selectlist],
    fieldTypeID: 5, // selectlist
    title: customProfileFieldHeaders[fieldTypes.selectlist],
    id: "selectlist",
    periodicIIGOn: true,
    ...commonProperties,
  },
  {
    label: "File Upload",
    icon: customProfileFieldIcons[fieldTypes.fileUpload],
    fieldTypeID: 6, // file upload
    title: customProfileFieldHeaders[fieldTypes.fileUpload],
    id: "fileUpload",
    periodicIIGOn: false,
    iigOn: false,
    ...commonProperties,
  },
];

export { customProfileFieldHeaders, customProfileFieldIcons };
export default extendedFieldsCustomFieldData;
